import React from 'react';
import BaseField from './components/Fields/BaseField';

export default function FieldsDisplay({ fields, disabled = false, renderer, props }) {
    return fields.map((field) => {
        const fieldProps = { ...props, disabled, renderer };
        return <BaseField renderer={renderer} field={field} props={fieldProps} />;
    });
}
